(function () {
  // Sblocca lo sticky toccando SOLO l'asse orizzontale (mai il verticale = mai blocco scroll)
  function fixStickyAncestors(el) {
    var node = el.parentElement;
    while (node && node !== document.documentElement) {
      if (getComputedStyle(node).overflowX === 'hidden') {
        node.style.overflowX = 'clip';
      }
      node = node.parentElement;
    }
  }

  function initMethod(outer) {
    fixStickyAncestors(outer);
    var blocks = Array.prototype.slice.call(outer.querySelectorAll('.mt__block'));
    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var rect = outer.getBoundingClientRect();
      var total = outer.offsetHeight - vh;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var progress = total > 0 ? scrolled / total : 1;
      blocks.forEach(function (b) {
        var t = parseFloat(b.getAttribute('data-reveal')) || 0;
        b.classList.toggle('is-visible', progress >= t);
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function boot() {
    if (!window.matchMedia('(min-width: 750px)').matches) return; // su mobile non gira
    document.querySelectorAll('[data-mt-id]').forEach(function (outer) {
      if (outer.dataset.mtInit) return;
      outer.dataset.mtInit = '1';
      initMethod(outer);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();